export default "__VITE_ASSET__dcd5ff10__"